import { useQuery } from '@tanstack/react-query';
import { getDashboardStatisticsRequest } from '@/api/statistics';

export const useDashboardStatistics = () => {
  return useQuery({
    queryKey: ['dashboard-statistics'],
    queryFn: getDashboardStatisticsRequest,
    staleTime: 5 * 60 * 1000, // 5 хвилин
    refetchInterval: 5 * 60 * 1000, // оновлення кожні 5 хвилин
  });
};

export default useDashboardStatistics;